import {
  useDebouncedValue,
  useSearchSimilarTickets,
  useToggleVote,
} from '@support/entities/support-ticket';
import { SimilarTicketsList } from './similar-tickets-list';

type SimilarTicketsProps = { query: string };

// Container: debounces the title as the reporter types, searches for similar
// tickets, and wires the upvote mutation. Advisory only — SimilarTicketsList
// renders nothing when there are no matches, and nothing here ever disables
// the create-ticket Submit button.
// @req SUPPORT-TICKET-003
export const SimilarTickets = ({ query }: SimilarTicketsProps) => {
  const debounced = useDebouncedValue(query, 300);
  const { data } = useSearchSimilarTickets(debounced);
  const vote = useToggleVote();

  return (
    <SimilarTicketsList
      items={data ?? []}
      onVote={(id) => vote.mutate({ id })}
      pendingId={vote.isPending ? (vote.variables?.id ?? null) : null}
    />
  );
};
